<div class="flex-row background" [class.past-timeline-row]="isPastDay" [class.current-timeline-row]="isCurrentDay" [style.padding-left.px]="paddingLeft">
  @for (item of scheduleItems; track $index) {
    @if (item.scheduleItem === null) {
      <ng-template [ngTemplateOutlet]="timelineRowButton" [ngTemplateOutletContext]="{width: item.width, index: $index}"> </ng-template>
    } @else {
      <div [style.width.px]="item.width" class="flex p-2">
        <vdw-schedule-item
          class="position-relative"
          [scheduleItem]="item.scheduleItem"
          [isPastDay]="isPastDay"
          [isCurrentDay]="isCurrentDay"
          [isSelected]="isSelected"
          (deleteEvent)="onScheduleItemDeleted(item.scheduleItem)"
          (checkboxEvent)="onScheduleItemCheckboxClicked()"
        ></vdw-schedule-item>
      </div>
    }
  }
</div>

<ng-template #timelineRowButton let-width="width" let-index="index">
  @if (width) {
    <div [style.width.px]="width" class="flex p-2">
      @if (!isPastDay && !isCurrentDay && isWorkingDay) {
        <vdw-timeline-row-button (click)="onRowButtonClicked(index)"></vdw-timeline-row-button>
      }
    </div>
  }
</ng-template>
